import { z } from 'zod';

// ---------------------------------------------------------------------------
// Favourite-sale event payload schemas
// ---------------------------------------------------------------------------

/**
 * Emitted daily by the cron when at >= 04:00 UTC (after retention at 03:00 UTC).
 * Payload is empty — the handler loads its own data.
 */
export const favouriteSaleScanSchema = z.object({});
export type FavouriteSaleScanPayload = z.infer<typeof favouriteSaleScanSchema>;

/** One on-sale item in a notify payload. */
export const favouriteSaleItemSchema = z.object({
  wallpaperId: z.number().int().positive(),
  title: z.string(),
  href: z.string(),
  oldPrice: z.string(),   // decimal-string, e.g. "99.00"
  newPrice: z.string(),   // decimal-string, e.g. "79.00"
  currency: z.string(),   // e.g. "PLN"
});
export type FavouriteSaleItem = z.infer<typeof favouriteSaleItemSchema>;

/**
 * Emitted by favourite-sale-scan, one per email that has newly on-sale items.
 * The handler renders and sends the email.
 */
export const favouriteSaleNotifySchema = z.object({
  email: z.string().email(),
  lang_code: z.string().default('pl'),
  unsubscribe_token: z.string(),
  items: z.array(favouriteSaleItemSchema).min(1),
});
export type FavouriteSaleNotifyPayload = z.infer<typeof favouriteSaleNotifySchema>;
